<template>
    <div class="mainC " style="background: #141416; color: lightgrey;">
     <div class="">
        <div style="height: 45px; background: #2c2d31; line-height: 45px; color: #E6E6E6; font-size: 12px;">
         <img style="width: 24px; margin-left: 20px; margin-bottom: 3px;" src="@/assets/profile.svg" />  {{ $t('LanguageEn.leaderboard') }}
        </div>
       <div>
            <div class="" style="background: #212225; height: 140px; line-height: 140px;">
              <img style="width: 70px; margin-left: 20px;" src="@/assets/leadercup.svg" /> <span style="color: lightgrey; font-weight: 550; margin-left: 10px; font-size: 14px;"> {{ $t('LanguageEn.leaderboard') }}</span>
            </div>
          </div>
          <div class="" style="height: 12px !important; background: #141416 !important;"></div>
        <!-- <li v-if="leaderList.length == 0" class="list-group-item listHeader" style="border-radius: 0px; background: #212225; font-size: 12px; color: #E6E6E6; height: 40px;"><img style="margin-bottom: 3px;" src="@/assets/noInfo.svg" />{{ $t('LanguageEn.noInfoa') }}</li> -->
        
        <!-- no tabs -->
        <div v-if="cookiesObject.lBoard == 'total'">
        <li v-if="leaderList.length == 0" class="list-group-item listHeader" style="border-radius: 0px; background: #212225; font-size: 12px; color: #E6E6E6; height: 40px;"><img style="margin-bottom: 3px;" src="@/assets/noInfo.svg" />{{ $t('LanguageEn.noInfoa') }}</li>
        <div v-else>
        <li class="container" style="color: #E6E6E6; background: #212225; height: 34px; line-height: 34px !important; list-style-type: none; font-size: 12px;">
            <div class="row">
            <div class="col-1" style="text-align: center;">
                #
            </div>
            <div class="col">
                {{ $t('LanguageEn.user') }}
            </div>
            <div class="col-2 pr-5">
                {{ $t('LanguageEn.score') }}
            </div>
        </div>
        </li>
        <li v-for="(some, i) in leaderList" :key="i" style="height: 40px; border: none; font-size: 12px; background: #141416; padding-left: 15px;" class="container list-group-item">
            <div class="row">
                 <div class="col-1" v-bind:class="{first: i == 0}" style="color: #E6E6E6; height: 40px; margin-top: -12px; text-align: center; border-bottom: 1px solid black;">
                  <p style="margin-top: 11px;"> {{i+1}} </p>
                </div>
                <div class="col" style="color: #E6E6E6; border-bottom: 1px solid #2c2d31;">
                 <span v-if="some.username.includes('*') == false"><img src="@/assets/arright.png" style="width: 13px;  margin-right: 5px;" alt=""></span> {{some.username}}
                </div>
                <div class="col-2" style="color: #E6E6E6; border-bottom: 1px solid #2c2d31;">
                   {{some.point}}
                </div>
            </div>
        </li>
        </div>
        </div>

        <!-- Tabs -->
          <b-tabs v-else v-model="tabIndex" class="Some " style="border-radius: 0px; color: #E6E6E6; background: #2c2d31; " nav-class="ks1"  active-nav-item-class="ks"  
            active-tab-class=""
            content-class=""
         >
         <b-tab style="border-radius: 0px;">
      <template v-slot:title>
        <p style="margin: 0px; font-weight:550; color: #E6E6E6; font-size: 12px; line-height: 25px;" v-if="tabIndex == 0"> {{ $t('LanguageEn.daily') }}</p> 
        <p style="margin: 0px; font-weight:550; color: grey; font-size: 12px; line-height: 25px;" v-else>{{ $t('LanguageEn.daily') }}</p>
      </template>
        <div class="" style="height: 12px !important; background: #141416 !important;"></div>
        <li v-if="leaderList.length == 0" class="list-group-item listHeader" style="border-radius: 0px; background: #212225; font-size: 12px; color: #E6E6E6; height: 40px;"><img style="margin-bottom: 3px;" src="@/assets/noInfo.svg" />No information available for now.</li>
        <div v-else>
        <li class="container" style="color: #E6E6E6; background: #212225; height: 34px; line-height: 34px !important; list-style-type: none; font-size: 12px;">
            <div class="row">
            <div class="col-1" style="text-align: center;">
                #
            </div>
            <div class="col">
                {{ $t('LanguageEn.user') }}
            </div>
            <div class="col-2 pr-5">
                {{ $t('LanguageEn.score') }}
            </div>
        </div>
        </li>
        <li v-for="(some, i) in leaderList" :key="i" style="height: 40px; border: none; font-size: 12px; background: #141416; padding-left: 15px;" class="container list-group-item">
            <div class="row">
                 <div class="col-1" v-bind:class="{first: i == 0}" style="color: #E6E6E6; height: 40px; margin-top: -12px; text-align: center; border-bottom: 1px solid black;">
                  <p style="margin-top: 11px;"> {{i+1}} </p>
                </div>
                <div class="col" style="color: #E6E6E6; border-bottom: 1px solid #2c2d31;">
                  <span v-if="some.username.includes('*') == false"><img src="@/assets/arright.png" style="width: 13px;  margin-right: 5px;" alt=""></span>{{some.username}}
                </div>
                <div class="col-2" style="color: #E6E6E6; border-bottom: 1px solid #2c2d31;">
                   {{some.point}}
                </div>
            </div>
        </li>
        </div>
     
          </b-tab>
           <b-tab style="border-radius: 0px;" @click="getList1()">
      <template v-slot:title>
        <p style="margin: 0px; font-weight:550; color: #E6E6E6; font-size: 12px; line-height: 25px;" v-if="tabIndex == 1">{{ $t('LanguageEn.weekly') }}</p> 
        <p style="margin: 0px; font-weight:550; color: grey; font-size: 12px; line-height: 25px;" v-else>{{ $t('LanguageEn.weekly') }}</p>
      </template>
       <div class="" style="height: 12px !important; background: #141416 !important;"></div>
        <li v-if="weekList.length == 0" class="list-group-item listHeader" style="border-radius: 0px; background: #212225; font-size: 12px; color: #E6E6E6; height: 40px;"><img style="margin-bottom: 3px;" src="@/assets/noInfo.svg" />No information available for now.</li>
        <div v-else>
        <li class="container" style="color: #E6E6E6; background: #212225; height: 34px; line-height: 34px !important; list-style-type: none; font-size: 12px;">
            <div class="row">
            <div class="col-1" style="text-align: center;">
                #
            </div>
            <div class="col">
                {{ $t('LanguageEn.user') }}
            </div>
            <div class="col-2 pr-5">
                {{ $t('LanguageEn.score') }}
            </div>
        </div>
        </li>
        <li v-for="(some, i) in weekList" :key="i" style="height: 40px; border: none; font-size: 12px; background: #141416; padding-left: 15px;" class="container list-group-item">
            <div class="row">
                 <div class="col-1" v-bind:class="{first: i == 0}" style="color: #E6E6E6; height: 40px; margin-top: -12px; text-align: center; border-bottom: 1px solid black;">
                  <p style="margin-top: 11px;"> {{i+1}} </p>
                </div>
                <div  class="col" style="color: #E6E6E6; border-bottom: 1px solid #2c2d31;">
                  <span v-if="some.username.includes('*') == false"><img src="@/assets/arright.png" style="width: 13px;  margin-right: 5px;" alt=""></span> {{some.username}}
                </div>
                <div class="col-2" style="color: #E6E6E6; border-bottom: 1px solid #2c2d31;">
                   {{some.point}}
                </div>
            </div>
        </li>
        </div>
     
      
          </b-tab>
           <b-tab style="border-radius: 0px;"  @click="getList2()">
      <template v-slot:title>
        <p style="margin: 0px; font-weight:550; color: #E6E6E6; font-size: 12px; line-height: 25px;" v-if="tabIndex == 2">{{ $t('LanguageEn.monthly') }}</p> 
        <p style="margin: 0px; font-weight:550; color: grey; font-size: 12px; line-height: 25px;" v-else>{{ $t('LanguageEn.monthly') }} </p>
      </template>
       <div class="" style="height: 12px !important; background: #141416 !important;"></div>
        <li v-if="monthList.length == 0" class="list-group-item listHeader" style="border-radius: 0px; background: #212225; font-size: 12px; color: #E6E6E6; height: 40px;"><img style="margin-bottom: 3px;" src="@/assets/noInfo.svg" />No information available for now.</li>
        <div v-else>
        <li class="container" style="color: #E6E6E6; background: #212225; height: 34px; line-height: 34px !important; list-style-type: none; font-size: 12px;">
            <div class="row">
            <div class="col-1" style="text-align: center;">
                #
            </div>
            <div class="col">
                {{ $t('LanguageEn.user') }}
            </div>
            <div class="col-2 pr-5">
                {{ $t('LanguageEn.score') }}
            </div>
        </div>
        </li>
        <li v-for="(some, i) in monthList" :key="i" style="height: 40px; border: none; font-size: 12px; background: #141416; padding-left: 15px;" class="container list-group-item">
            <div class="row">
                 <div class="col-1" v-bind:class="{first: i == 0}" style="color: #E6E6E6; height: 40px; margin-top: -12px; text-align: center; border-bottom: 1px solid black;">
                  <p style="margin-top: 11px;"> {{i+1}} </p>
                </div>
                <div  class="col" style="color: #E6E6E6; border-bottom: 1px solid #2c2d31;">
                  <span v-if="some.username.includes('*') == false"><img src="@/assets/arright.png" style="width: 13px;  margin-right: 5px;" alt=""></span> {{some.username}}
                </div>
                <div class="col-2" style="color: #E6E6E6; border-bottom: 1px solid #2c2d31;">
                   {{some.point}}
                </div>
            </div>
        </li>
        </div>
     
     
          </b-tab>
         </b-tabs>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'Leaderboard',
   data(){
      return{
        leaderList: [],
        weekList: [],
        monthList: [],
        yList: [],
        cookiesObject: '',
        tabIndex: 0,
      }
  },
  async beforeMount(){
    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;

    if (cookiesObject.lBoard == 'total') {
      this.getList();
    } else {
      this.getList0();
    }
    
  },

  methods:{
     getList(){
        var myHeaders = new Headers();
        myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        fetch(this.httpReq +"/game/leaderboard?token=" + this.cookiesObject.token +"&type=" + this.cookiesObject.lBoard, requestOptions)
        .then(response => response.json())
        .then(result => {
            this.leaderList = result.users;

        })
        .catch(error => console.log('error', error));
    },
     getList0(){
        var myHeaders = new Headers();
        myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        fetch(this.httpReq +"/game/leaderboard?token=" + this.cookiesObject.token +"&type=" + this.cookiesObject.lBoard.split(',')[0], requestOptions)
        .then(response => response.json())
        .then(result => {
            this.leaderList = result.users;

        })
        .catch(error => console.log('error', error));
    },
      getList1(){
        var myHeaders = new Headers();
        myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        fetch(this.httpReq +"/game/leaderboard?token=" + this.cookiesObject.token +"&type=" + this.cookiesObject.lBoard.split(',')[1] , requestOptions)
        .then(response => response.json())
        .then(result => {
            this.weekList = result.users;

        })
        .catch(error => console.log('error', error));
    },
      getList2(){
        var myHeaders = new Headers();
        myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        fetch(this.httpReq +"/game/leaderboard?token=" + this.cookiesObject.token +"&type=" + this.cookiesObject.lBoard.split(',')[2], requestOptions)
        .then(response => response.json())
        .then(result => {
            this.monthList = result.users;

        })
        .catch(error => console.log('error', error));
    },
    getList3(){
        var myHeaders = new Headers();
        myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        fetch(this.httpReq +"/game/leaderboard?token=" + this.cookiesObject.token +"&type=yesterday", requestOptions)
        .then(response => response.json())
        .then(result => {
            this.yList = result.users;

        })
        .catch(error => console.log('error', error));
    },
  },
  components: {
   
  },
  computed:{
    ...mapGetters(['httpReq']),
  },
}
</script>

<style scoped>
.first{
  background: #355D38;
}
.second{
  background: #6E552F;
}
.other{
   background: #3c3e43; 
}
.last{
   background: #79323A; 
}

.mainC{
    margin-top: 0px !important;
}


.LeagueName{
    margin-bottom: 10px;
}

.header{
    background: #d6d6d6;
    color: black;
}

.bodyElement{
    padding: 0;
    height: 28px;
}

.game{
    text-align: center;
}
.game :hover{
    color: #309a3d;
}

@media only screen and (max-width: 770px) {
  body{
    background: #212529;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}

</style>
